import { apiAction } from "../models/requests";

export function createAccount(accountData) {
    return apiAction({
        types: ["CREATE_ACCOUNT_REQUESTED", "CREATE_ACCOUNT_SUCCESS", "CREATE_ACCOUNT_FAILED"],
        method: "POST",
        path: "subscriptions/createAccount",
        body: accountData
    });
}
